import { useEffect } from 'react';

import analyticsService from '../services/analyticsService';

export default function useAnalytics(apiKey: string) {
  useEffect(() => {
    analyticsService.load(apiKey);
  }, []);
}
